import type { CSSObject } from 'styled-components';
import { css } from 'styled-components';

export type WithSX<P = {}> = P & { $sx: CSSObject };

export const applySX = (props: WithSX) => css(props.$sx);
